// Auto-generated file. Do not modify.
export const APP_VERSION = '2.0.0.35';
export const BUILD_NUMBER = 35;
export const VERSION = '2.0.0';
export const FULL_VERSION = '2.0.0.35';
export const GIT_HASH = '8524460';
export const GIT_BRANCH = 'release-v2.0.0';
export const BUILD_INFO = '2.0.0.35 (8524460)';
export const RELEASE_NAME = '';
